var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { ICON_SVG, ICON_COLORABLE } from '../../icons/generated.js';
const COLOR_TOKEN_TO_CSS = {
    primary: 'var(--ggo-color-primary, #2563eb)',
    secondary: 'var(--ggo-color-secondary, #6b7280)',
    tertiary: 'var(--ggo-color-tertiary, #94a3b8)',
    danger: 'var(--ggo-color-danger, #dc3545)',
    warning: 'var(--ggo-color-warning, #ffc107)',
    success: 'var(--ggo-color-success, #28a745)',
    info: 'var(--ggo-color-info, #17a2b8)',
};
export const ICON_COLOR_TOKENS = Object.keys(COLOR_TOKEN_TO_CSS);
function resolveSize(size) {
    if (size === undefined || size === null || size === '')
        return '20px';
    if (typeof size === 'number')
        return `${size}px`;
    const trimmed = size.trim();
    return /^\d+(\.\d+)?$/.test(trimmed) ? `${trimmed}px` : trimmed;
}
function resolveColor(color) {
    if (!color)
        return null;
    const trimmed = color.trim();
    if (!trimmed)
        return null;
    if (trimmed in COLOR_TOKEN_TO_CSS) {
        return COLOR_TOKEN_TO_CSS[trimmed];
    }
    return trimmed;
}
let GgoIcon = class GgoIcon extends LitElement {
    constructor() {
        super(...arguments);
        this.size = 20;
    }
    updated(changed) {
        if (changed.has('size')) {
            this.style.setProperty('--ggo-icon-size', resolveSize(this.size));
        }
        if (changed.has('color')) {
            const resolved = resolveColor(this.color);
            if (resolved) {
                this.style.setProperty('color', resolved);
            }
            else {
                this.style.removeProperty('color');
            }
        }
    }
    render() {
        const svg = ICON_SVG[this.name];
        if (!svg) {
            console.warn(`[basic-icon] Unknown icon name: "${this.name}"`);
            return nothing;
        }
        return this.label
            ? html `<span role="img" aria-label="${this.label}">${unsafeHTML(svg)}</span>`
            : html `<span aria-hidden="true">${unsafeHTML(svg)}</span>`;
    }
    /** Whether this icon's color can be visually overridden via `color`. */
    static isColorable(name) {
        return ICON_COLORABLE[name] === true;
    }
};
GgoIcon.styles = css `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: var(--ggo-icon-size, 20px);
      height: var(--ggo-icon-size, 20px);
      color: currentColor;
      line-height: 0;
      flex: 0 0 auto;
    }
    :host > span {
      display: inline-flex;
      width: 100%;
      height: 100%;
    }
    :host svg {
      width: 100%;
      height: 100%;
      display: block;
    }
  `;
__decorate([
    property({ type: String })
], GgoIcon.prototype, "name", void 0);
__decorate([
    property()
], GgoIcon.prototype, "size", void 0);
__decorate([
    property({ type: String })
], GgoIcon.prototype, "color", void 0);
__decorate([
    property({ type: String })
], GgoIcon.prototype, "label", void 0);
GgoIcon = __decorate([
    customElement('basic-icon')
], GgoIcon);
export { GgoIcon };
//# sourceMappingURL=Icon.js.map